// @flow

import React, { Component } from 'react'
import moment from 'moment'
import { isInclusivelyAfterDay } from 'react-dates'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isMobile } from 'common/screen'
import { setUIState } from 'redux/modules/ui'
import { actions as RoomActions } from 'redux/modules/room'
import InquiryModal from 'components/organisms/room/InquiryModal'
import { type Room as RoomType } from 'types/room'

import InquiryModalUseCase, { type InquirymodalUseCaseType } from './usecase'

type PropTypes = {
  room: RoomType,
  usecase: InquirymodalUseCaseType,
  ui: Object,
}

class InquiryModalContainer extends Component<PropTypes> {
  constructor(props: PropTypes) {
    super(props)

    const { usecase } = this.props
    usecase.initialize()
  }

  // 日付選択dayPickerのprops整形
  dayPickerProps = () => {
    const { ui, usecase } = this.props
    const inquiry = ui.inquiry || {}

    return {
      monthFormat: i18n.t('page.search.dayPickerMonthFormat'),
      numberOfMonths: isMobile() ? 1 : 2,
      isOutsideRange: (day: any) => !isInclusivelyAfterDay(day, moment()),
      hideKeyboardShortcutsPanel: true,
      startDate: ui.startDate || inquiry.startDate,
      endDate: ui.endDate || inquiry.endDate,
      focusedInput: ui.calendarFocusedInput,
      onDatesChange: (changed: { startDate: moment, endDate: moment }) => {
        const { startDate, endDate } = changed
        usecase.changeCalendarDate(startDate, endDate)
      },
      onFocusChange: (changedFocusedInput: string) => {
        usecase.changeCalendarFocusedInput(
          !changedFocusedInput ? 'startDate' : changedFocusedInput,
        )
      },
      minimumNights: 0,
    }
  }

  // 価格選択sliderのprops整形
  budgetRangeProps = () => {
    const { ui, usecase } = this.props
    return {
      min: 0,
      max: 101000,
      step: 1000,
      pushable: true,
      allowCross: false,
      value: [ui.minPrice || 0, ui.maxPrice || 101000],
      onChange: (values: Array<number>) => {
        usecase.changePrice(values)
      },
      onAfterChange: () => {},
    }
  }

  planDateText = () => {
    const { ui } = this.props
    const inquiry = ui.inquiry || {}
    if (inquiry.startDate && inquiry.endDate) {
      return `${inquiry.startDate.format(
        i18n.t('page.shared.dateFormat1'),
      )}〜${inquiry.endDate.format(i18n.t('page.shared.dateFormat1'))}`
    }

    return ''
  }

  render() {
    const { ui, room, usecase } = this.props

    return (
      <InquiryModal
        ui={ui}
        eventTypes={(room.eventTypes || {}).results || []}
        planDateText={this.planDateText()}
        dayPickerProps={this.dayPickerProps()}
        budgetRangeProps={this.budgetRangeProps()}
        onChangeEventType={usecase.changeEventType}
        onChangeUseType={usecase.changeUseType}
        onChangeCapacity={usecase.changeCapacity}
        onChangeDescription={usecase.changeDescription}
        onChangeCheckPreview={usecase.changePreviewCheck}
        onClickCalendarContainer={usecase.openCalendar}
        onClickApplyCalendar={(e: Event) =>
          usecase.applyDatePick(e, ui.startDate, ui.endDate)
        }
        onClickCancelCalendar={usecase.cancelDatePick}
        onClickSend={usecase.sendInquiry}
        onClickClose={usecase.closeInquiryModal}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
  }
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...RoomActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InquiryModalUseCase(InquiryModalContainer)),
)



// WEBPACK FOOTER //
// ./src/containers/organisms/room/InquiryModal/index.jsx